<template>
  <div class="section-main__warp work-order work-order-list" v-loading="loadingWorderList"
    element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
    <div class="header">
      <div class="flex-auto">
        <el-button type="primary" size="small" style="padding: 7px 10px" class="iss-operation-button"
          icon="iconfont icon-iconfontfanhui" @click="handleBack">返回</el-button>
        <el-button type="primary" size="small" style="padding: 7px 10px" class="iss-operation-button"
          icon="iconfont icon-xiugai" @click="editTable"
          v-if="authList.indexOf('workOrder:updateWorkOrderField') != -1">{{ $t("workOrder.label.editTable") }}
        </el-button>
        <el-button type="primary" size="small" style="padding: 7px 10px" class="iss-operation-button"
          icon="iconfont icon-Group" v-if="
            workOrderType != 2 &&
            authList.indexOf('workOrder:addWorkOrderFlow') != -1
          " @click="editFlow">{{ $t("workOrder.label.editFlow") }}</el-button>
      </div>
      <div class="title flex-auto">{{ templateName }}</div>
      <div class="flex-auto"></div>
    </div>
    <div class="body">
      <div class="right-area no-margin showBorder">
        <ioc-table :data="workOrderList" :option="tableOption" :page="page" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" @selection-change="handleSelectionChange">
          <template v-for="colorItem in colorProp" #[colorItem]="colorData">
            <span v-if="colorData.row[colorItem]" :key="colorItem">
              <span class="colorSpan" v-for="spanItem in colorData.row[colorItem].split('|')" :key="spanItem" :style="{
                background: spanItem ? spanItem.split(':')[1] || '' : '',
              }">{{ spanItem.split(":")[0] }}</span>
            </span>
          </template>
          <template v-for="item in imgProp" #[item]="imgData">
            <img :src="getImgPath(imgData.row, item)" :key="item" v-if="imgData.row[item]"
              @click="showViewer(getImgPath(imgData.row, item))" onerror="this.src='/images/theme/newDark/default.png'"
              style="height: 25px; width: 50px" />
          </template>
          <template slot="menu" slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="编辑"
              v-if="authList.indexOf('workOrder:updateWorkOrder') != -1" placement="top" popper-class="tooltip-draw">
              <el-button type="text" icon="iconfont icon-xiugai" @click="handleRowClick(scope.row, -1)"></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="详情" placement="top" popper-class="tooltip-draw">
              <el-button type="text" icon="iconfont icon-Detail" @click="handleRowClick(scope.row, scope.index)">
              </el-button>
            </el-tooltip>
          </template>
          <template slot="menuRight">
            <el-button type="primary" size="small" style="padding: 7px 10px; margin-right: 10px"
              class="iss-operation-button" icon="el-icon-search" @click="showDrawer(true)">自定义筛选</el-button>
            <el-button type="primary" size="small" style="padding: 7px 10px; margin-right: 10px"
              class="iss-operation-button" icon="el-icon-s-tools" @click="showDrawer">字段设置</el-button>

            <el-button type="primary" size="small" style="padding: 7px 10px" class="iss-operation-button"
              icon="el-icon-camera" v-if="executorFlag == 0" @click="handleQr">扫码</el-button>
            <el-button type="primary" size="small" style="padding: 7px 10px" class="iss-operation-button"
              v-if="authList.indexOf('workOrder:deleteWorkOrder') != -1" icon="el-icon-delete"
              :disabled="!workOrderList.length ? true : false" @click="handleDel">删除</el-button>
            <el-button type="primary" size="small" v-if="authList.indexOf('workOrder:addWorkOrder') != -1"
              style="padding: 7px 10px" class="iss-operation-button" icon="el-icon-plus" @click="handleAdd">新增
            </el-button>
            <el-button type="primary" class="iss-operation-button" style="padding: 7px 10px" icon="el-icon-connection"
              :disabled="!workOrderList.length ? true : false" :loading="exportDisabled" @click="exportFile">{{
                  exportDisabled ? "导出中..." : "导出"
              }}</el-button>
          </template>
        </ioc-table>
      </div>
    </div>
    <!-- 自定义筛选 -->
    <el-drawer title="自定义筛选" :visible.sync="drawerFilter" :before-close="() => (drawerFilter = false)" size="300px">
      <div class="demo-drawer__content">
        <div>
          <div style="text-align:center;font-size:16px;margin-bottom:15px">
            {{ workOrderType == 2 ? '创建人' : '提交人' }}信息
          </div>
          <el-collapse>
            <el-collapse-item v-for="(item, index) in tableField.filter(el => {
              return el.flowType == 1 || !el.flowType
            })" :key="index">
              <template slot="title">
                <span :title="item.label" class="title">
                  {{ item.label }}
                </span>
              </template>
              <div v-if="inputType.indexOf(Number(item.type)) != -1 || item.label == '创建人' || item.label == '工单编号'">
                <el-input placeholder="请输入搜索内容" v-model="item.searchValue" clearable></el-input>
              </div>
              <div v-if="item.type == 4 || item.label == '创建时间'">
                <el-date-picker type="date" v-model="item.searchValue" style="width:100% !important" value-format="yyyy-MM-dd"
                  placeholder="选择日期">
                </el-date-picker>
              </div>
              <div v-if="item.type == 5">
                <el-radio-group class="margin10" v-model="item.searchValue">
                  <el-radio v-for="(name, i) in item.optionName" :key="i" :label="name.split(':')[0]">
                    <span :style="{
                      color: name.split(':')[1]
                    }">
                      {{ name.split(':')[0] }}
                    </span>
                  </el-radio>
                </el-radio-group>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div v-if="tableField.findIndex(el => el.flowType == 2) != -1">
          <div style="text-align:center;font-size:16px;margin:15px 0">
            {{ workOrderType == 2 ? '违规人' : '执行人' }}信息
          </div>
          <el-collapse>
            <el-collapse-item v-for="(item, index) in tableField.filter(el => {
              return el.flowType == 2
            })" :key="index">
              <template slot="title">
                <span :title="item.label" class="title">
                  {{ item.label }}
                </span>
              </template>
              <div v-if="inputType.indexOf(Number(item.type)) != -1 || item.label == '创建人' || item.label == '工单编号'">
                <el-input placeholder="请输入搜索内容" v-model="item.searchValue" clearable></el-input>
              </div>
              <div v-if="item.type == 4 || item.label == '创建时间'">
                <el-date-picker type="date" v-model="item.searchValue" style="width:100%" placeholder="选择日期">
                </el-date-picker>
              </div>
              <div v-if="item.type == 5">
                <el-radio-group class="margin10" v-model="item.searchValue">
                  <el-radio v-for="(name, i) in item.optionName" :key="i" :label="name.split(':')[0]">
                    <span :style="{
                      color: name.split(':')[1]
                    }">
                      {{ name.split(':')[0] }}
                    </span>
                  </el-radio>
                </el-radio-group>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>

      <div class="demo-drawer__footer">
        <el-button @click="drawerFilter = false">取 消</el-button>
        <el-button type="info" @click="subDrawerFilter(false)">重 置</el-button>
        <el-button type="primary" @click="subDrawerFilter" :loading="subLoading">{{ subLoading ? "提交中 ..." : "确 定" }}
        </el-button>
      </div>
    </el-drawer>
    <!-- 字段显示配置 -->
    <el-drawer title="表格字段显示配置" :visible.sync="drawer" :before-close="() => (drawer = false)" size="300px">
      <div class="demo-drawer__content">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" class="checkItem"
          @change="handleCheckAllChange">全选</el-checkbox>
        <el-checkbox-group v-model="checkedfields" @change="handleCheckedTableChange">
          <el-checkbox v-for="(item, index) in tableField" :key="item.prop" class="checkItem"
            :class="[index == flowTypeIndex ? 'filterCheck' : '']" :label="item.prop">
            <span :title="item.label"> {{ item.label }}</span>
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="drawer = false">取 消</el-button>
        <el-button type="primary" @click="subDrawer" :loading="subLoading">{{ subLoading ? "提交中 ..." : "确 定" }}
        </el-button>
      </div>
    </el-drawer>
    <!--导出时间筛选-->
    <el-dialog title="导出时间选择" v-dialogDrag :visible.sync="exportVisible" width="520px" @closed="closeTimeDialog"
      class="detail-continer">
      <div class="iss-operation-button time-range">
        <label>时间：</label>
        <el-date-picker v-model="timeRange" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
      </div>
      <div class="footer" slot="footer">
        <el-button @click="closeTimeDialog">取消</el-button>
        <el-button @click="timeConfirm" type="primary">确认</el-button>
      </div>
    </el-dialog>
    <!--告警详情-->
    <iocDialog ref="alarmDetail" v-dialogDrag :title="$t('historyAlarm.title.alarmDetail')" :showFooter="false"
      width="700px" class="test-class" @close="closeDialog">
      <div class="ioc-detail">
        <div class="ioc-group" v-if="currentAlarm.subSystem != '12'">
          <div class="el-row ioc-group__item" span="24">
            <div class="ioc-group__header">
              <!---->
              <h3 class="ioc-group__title">
                {{ $t("historyAlarm.title.SnapshotPreview") }}
              </h3>
            </div>
            <div class="ioc-detail__image" style="margin: 10px 0">
              <template v-if="currentAlarm.alarmSnapUrl || currentAlarm.picUrl">
                <div v-if="
                  currentAlarm.alarmType == '50102' &&
                  currentAlarm.subSystem !== '9'
                " key="alarmPicture" class="flex-between black-list-pic-area">
                  <div class="black-list-pic">
                    <span class="pic-title">抓拍人员</span>
                    <img class="lookPhoto" v-if="currentAlarm.alarmSnapUrl || currentAlarm.picUrl" :src="
                      imgPath(
                        currentAlarm.alarmSnapUrl || currentAlarm.picUrl
                      )
                    " alt @click="showViewer" onerror="this.src='/images/theme/newDark/default.png'" />
                  </div>
                  <div class="black-list-pic">
                    <span class="pic-title">黑名单人员</span>
                    <img class="lookPhoto" v-if="currentAlarm.picFileId" :src="imgPath(currentAlarm.picFileId)" alt
                      @click="showViewer" onerror="this.src='/images/theme/newDark/default.png'" />
                  </div>
                  <span class="similarity-text">{{ currentAlarm.similarity }}%</span>
                </div>

                <el-carousel style="height: 180px; overflow: hidden" v-else-if="currentAlarm.subSystem === '9'">
                  <el-carousel-item v-for="item in (currentAlarm.picUrl || '').split(',')" :key="item">
                    <img class="lookPhoto" :src="imgPath(item)" style="width: 300px; height: 180px" alt
                      @click="showViewer" onerror="this.src='/images/theme/newDark/default.png'" />
                  </el-carousel-item>
                </el-carousel>

                <el-carousel style="height: 180px; overflow: hidden" v-else>
                  <el-carousel-item v-for="item in (currentAlarm.alarmSnapUrl || '').split(',')" :key="item">
                    <img class="lookPhoto" :src="imgPath(item)" style="width: 300px; height: 180px" alt
                      @click="showViewer" onerror="this.src='/images/theme/newDark/default.png'" />
                  </el-carousel-item>
                </el-carousel>
              </template>

              <template v-else>
                <img style="height: 120px; width: 100%" :src="`/images/theme/newDark/no-img.jpg`" />
              </template>
            </div>
          </div>
        </div>
        <div class="ioc-group" style="margin: 15px 0">
          <div class="el-row ioc-group__item" span="24">
            <div class="ioc-group__header">
              <!---->
              <h3 class="ioc-group__title">
                {{ currentAlarm.subSystem !== "12" ? "" : "一键求救-"
                }}{{ $t("historyAlarm.title.alarmDetail") }}
              </h3>
            </div>
            <!---->
            <!---->
            <div class="el-col el-col-24 el-col-xs-24 el-col-md-12">
              <div class="ioc-detail__box mt10">
                <span class="ioc-detail__label ioc-detail__label--right">{{
                    $t("historyAlarm.title.alarmName")
                }}</span>
                <!---->
                <span class="ioc-detail__content pl5">{{
                    currentAlarm.alarmName
                }}</span>
                <!-- <span class="ioc-detail__content alarm-name"
                      :title="alarmName(currentAlarm.alarmType)">{{ alarmName(currentAlarm.alarmType) }}</span> -->
              </div>
            </div>

            <!---->
            <div class="el-col el-col-24 el-col-xs-24 el-col-md-12">
              <div class="ioc-detail__box mt10">
                <span class="ioc-detail__label ioc-detail__label--right">{{ $t("historyAlarm.title.alarmType") }}:
                </span>
                <!---->
                <span class="ioc-detail__content pl5">{{
                    currentAlarm.alarmTypeLabel
                }}</span>
                <!-- <span class="ioc-detail__content pl5"
                      v-if="currentAlarm.alarmType == '60101'">{{ currentAlarm.alarmType | dic('SENU004006') }}</span>
                <span class="ioc-detail__content pl5"
                      v-else>{{ currentAlarm.alarmType | dic('SENU004005') }}</span> -->
              </div>
            </div>
            <div class="el-col el-col-24 el-col-xs-24 el-col-md-12" v-if="currentAlarm.alarmType == '80101'">
              <div class="ioc-detail__box mt10">
                <span class="ioc-detail__label ioc-detail__label--right">限速</span>
                <!---->
                <span class="ioc-detail__content pl5">{{ currentAlarm.overSpeed }}km/h</span>
                <!-- <span class="ioc-detail__content alarm-name"
                      :title="alarmName(currentAlarm.alarmType)">{{ alarmName(currentAlarm.alarmType) }}</span> -->
              </div>
            </div>
            <div class="el-col el-col-24 el-col-xs-24 el-col-md-12" v-if="currentAlarm.alarmType == '80101'">
              <div class="ioc-detail__box mt10">
                <span class="ioc-detail__label ioc-detail__label--right">当前车速</span>
                <!---->
                <span class="ioc-detail__content pl5">{{ currentAlarm.speed }}km/h</span>
                <!-- <span class="ioc-detail__content alarm-name"
                      :title="alarmName(currentAlarm.alarmType)">{{ alarmName(currentAlarm.alarmType) }}</span> -->
              </div>
            </div>
            <div class="el-col el-col-24 el-col-xs-24 el-col-md-12" v-if="currentAlarm.alarmType == '80101'">
              <div class="ioc-detail__box mt10">
                <span class="ioc-detail__label ioc-detail__label--right">上浮速度</span>
                <!---->
                <span class="ioc-detail__content pl5">{{ currentAlarm.floatSpeed }}km/h</span>
                <!-- <span class="ioc-detail__content alarm-name"
                      :title="alarmName(currentAlarm.alarmType)">{{ alarmName(currentAlarm.alarmType) }}</span> -->
              </div>
            </div>
            <div class="el-col el-col-24 el-col-xs-24 el-col-md-12" v-if="currentAlarm.alarmType == '80101'">
              <div class="ioc-detail__box mt10">
                <span class="ioc-detail__label ioc-detail__label--right">车牌</span>
                <!---->
                <span class="ioc-detail__content pl5">{{
                    currentAlarm.plateNo
                }}</span>
                <!-- <span class="ioc-detail__content alarm-name"
                      :title="alarmName(currentAlarm.alarmType)">{{ alarmName(currentAlarm.alarmType) }}</span> -->
              </div>
            </div>
            <!---->
            <div class="el-col el-col-24 el-col-xs-24 el-col-md-12">
              <div class="ioc-detail__box mt10">
                <span class="ioc-detail__label ioc-detail__label--right">{{ $t("historyAlarm.title.alarmLevel")
                }}:</span>
                <!---->
                <span class="ioc-detail__content pl5">{{
                    currentAlarm.alarmLevel | dic("SENU017")
                }}</span>
              </div>
            </div>
            <!---->
            <div class="el-col el-col-24 el-col-xs-24 el-col-md-12">
              <div class="ioc-detail__box mt10">
                <span class="ioc-detail__label ioc-detail__label--right">{{ $t("historyAlarm.title.alarmTime")
                }}:</span>
                <!---->
                <span class="ioc-detail__content pl5">{{
                    currentAlarm.alarmTime | moment
                }}</span>
              </div>
            </div>
            <!---->
            <div class="el-col el-col-24 el-col-xs-24 el-col-md-12">
              <div class="ioc-detail__box mt10">
                <span class="ioc-detail__label ioc-detail__label--right">设备组名称:</span>
                <!---->
                <span class="ioc-detail__content pl5">{{
                    currentAlarm.deviceWorkGroupName
                }}</span>
              </div>
            </div>
            <!---->
            <div class="el-col el-col-24 el-col-xs-24 el-col-md-12">
              <div class="ioc-detail__box mt10">
                <span class="ioc-detail__label ioc-detail__label--right">所属中队:</span>
                <!---->
                <span class="ioc-detail__content pl5">{{
                    currentAlarm.securityWorkGroupNames
                }}</span>
              </div>
            </div>
            <div class="el-col el-col-24 el-col-xs-24 el-col-md-12" v-if="currentAlarm.subSystem != '12'">
              <div class="ioc-detail__box">
                <span class="ioc-detail__label ioc-detail__label--right">{{
                    $t("historyAlarm.title.videoPlayback")
                }}</span>
                <span class="ioc-detail__content pl5">
                  <span v-if="!currentAlarm.playBackUrl">{{
                      $t("historyAlarm.label.no")
                  }}</span>
                  <el-button type="text" v-else @click="viewVideo()">{{
                      $t("historyAlarm.button.View")
                  }}</el-button>
                </span>
              </div>
            </div>
            <div class="el-col el-col-24 el-col-xs-24 el-col-md-12"
              v-if="uploadVideoShow && currentAlarm.subSystem != '12'">
              <div class="ioc-detail__box">
                <span class="ioc-detail__label ioc-detail__label--right">{{
                    $t("historyAlarm.label.uploadVideo")
                }}</span>
                <span class="ioc-detail__content pl5">
                  <span v-if="!currentAlarm.videoUrl">{{
                      $t("historyAlarm.label.no")
                  }}</span>
                  <el-button type="text" v-else @click="lookUploadVideo()">{{
                      $t("historyAlarm.button.View")
                  }}</el-button>
                </span>
              </div>
            </div>
            <div class="el-col el-col-24 el-col-xs-24 el-col-md-12" v-show="currentAlarm.reportPersonName">
              <div class="ioc-detail__box">
                <span class="ioc-detail__label ioc-detail__label--right">{{
                    $t("historyAlarm.label.reportTo")
                }}</span>
                <!---->
                <span class="ioc-detail__content pl5">{{
                    currentAlarm.reportPersonName
                }}</span>
              </div>
            </div>
            <!-- 一键求救 -->
            <div class="el-col el-col-24 el-col-xs-24 el-col-md-12" v-if="currentAlarm.subSystem == '12'">
              <div class="ioc-detail__box mt10">
                <span class="ioc-detail__label ioc-detail__label--right">故障类型：</span>
                <!---->
                <span class="ioc-detail__content pl5">{{
                    currentAlarm.alarmSubType | dic("SENU103")
                }}</span>
              </div>
            </div>
            <div class="el-col el-col-24 el-col-xs-24 el-col-md-12" v-if="currentAlarm.subSystem == '12'">
              <div class="ioc-detail__box mt10">
                <span class="ioc-detail__label ioc-detail__label--right">一键求救设备：</span>
                <!---->
                <span class="ioc-detail__content pl5">{{
                    currentAlarm.deviceName
                }}</span>
              </div>
            </div>
            <div class="el-col el-col-24 el-col-xs-24 el-col-md-12" v-if="currentAlarm.subSystem == '12'">
              <div class="ioc-detail__box mt10">
                <span class="ioc-detail__label ioc-detail__label--right">设备位置：</span>
                <span class="ioc-detail__content pl5">{{
                    currentAlarm.groupName
                }}</span>
              </div>
            </div>
            <div class="el-col el-col-24 el-col-xs-24 el-col-md-24">
              <div class="ioc-detail__box mt10">
                <span class="ioc-detail__label ioc-detail__label--right">{{
                    $t("historyAlarm.label.warnDesc")
                }}</span>
                <span class="ioc-detail__content handle-desc pl5">{{
                    currentAlarm.desc
                }}</span>
              </div>
            </div>
            <!---->
          </div>
        </div>
        <div class="ioc-group">
          <div class="el-row ioc-group__item" span="24">
            <div class="ioc-group__header">
              <h3 class="ioc-group__title">
                {{ $t("historyAlarm.title.dealWith") }}
              </h3>
            </div>
            <div class="el-col el-col-24 el-col-xs-24 el-col-md-12">
              <div class="ioc-detail__box mt10">
                <span class="ioc-detail__label ioc-detail__label--right">{{
                    $t("historyAlarm.title.Processingpers")
                }}</span>
                <span class="ioc-detail__content pl5">{{
                    currentAlarm.modifier
                }}</span>
              </div>
            </div>
            <div class="el-col el-col-24 el-col-xs-24 el-col-md-24">
              <div class="ioc-detail__box mt10">
                <span class="ioc-detail__label ioc-detail__label--right">{{
                    $t("historyAlarm.title.ProcessingDes")
                }}</span>
                <!---->
                <span class="ioc-detail__content pl5 handle-desc">{{
                    currentAlarm.processDesc
                }}</span>
              </div>
            </div>
            <!---->
          </div>
        </div>
      </div>
      <div class="tc mt15">
        <el-button type="primary" v-show="currentAlarm && currentAlarm.taskCode" @click="handelShowTaskDetail">
          {{ $t("historyAlarm.title.viewTask") }}
        </el-button>
      </div>
    </iocDialog>
    <iocDialog ref="taskDetail" :title="$t('historyAlarm.title.taskDetail')" :showFooter="false"
      class="taskDetail-container" width="600px">
      <ioc-detail :option="taskOption" v-model="currentTask"></ioc-detail>
      <div class="ioc-detail__box clearfix img-content mt10">
        <span class="ioc-detail__label ioc-detail__label--right">{{
            $t("historyAlarm.label.relatedDocuments")
        }}</span>
        <span class="ioc-detail__content fl">
          <app-file-list-show :fileInfoList="currentTask.fileInfoList" :taskAlarmInfo="currentAlarm"
            @enlargeImage="enlargeImage"></app-file-list-show>
        </span>
      </div>
      <!-- <ioc-tabs :option="tapOption"
                @change="handleTabChange"></ioc-tabs> -->
      <ioc-tab-group :option="tapOption" @change="handleTabChange"></ioc-tab-group>
      <div v-if="currentTab.prop === 'tab1' || !currentTab.prop" style="height: 140px; overflow-y: scroll">
        <el-table ref="personList" :data="currentTask.subTaskInfoList" style="width: 100%">
          <el-table-column prop="executor" :label="$t('historyAlarm.label.exeNumber')">
          </el-table-column>
          <el-table-column prop="executorName" :label="$t('historyAlarm.label.executive')">
          </el-table-column>
          <el-table-column prop="status" :label="$t('historyAlarm.label.implementation')">
            <template slot-scope="scope">
              {{ scope.row.status | dic("SENU055") }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-else-if="currentTab.prop === 'tab2'" style="padding: 0 20px; height: 140px; overflow-y: scroll">
        <!-- <ioc-timeline>
          <ioc-timeline-item v-for="item in currentTask.taskExecutionLogList"
                             :key="item.id">
            <div>{{ item.operateTime | moment }}</div>
            <div>{{ $t('historyAlarm.label.executive') }}{{ item.operator }}</div>
            <div>{{ $t('historyAlarm.label.executiveAct') }}{{ item.action | dic('SENU056') }}</div>
            <div>{{ $t('historyAlarm.label.executiveDes') }}{{ item.desc }}</div>
          </ioc-timeline-item>
        </ioc-timeline> -->

        <div>
          <el-timeline>
            <el-timeline-item v-for="(activity, index) in currentTask.taskExecutionLogList" :key="index" placement="top"
              :timestamp="activity.operateTime | moment">
              <p>执行人：{{ activity.operator }}</p>
              <p>执行动作：{{ formatter(execute, activity.action) }}</p>
              <p>催办执行人：{{ activity.executor }}</p>
              <p class="word-break-all">描述：{{ activity.desc }}</p>
              <el-row>
                <el-col :span="3"> 相关文件： </el-col>
                <el-col :span="18">
                  <app-file-list-show :fileInfoList="activity.fileInfos" @enlargeImage="enlargeImage">
                  </app-file-list-show>
                </el-col>
              </el-row>
            </el-timeline-item>
          </el-timeline>
          <!-- 执行明细无数据时展示暂无数据 -->
          <div v-if="currentTask.taskExecutionLogList.length === 0" class="table-empty" style="text-align: center">
            <img src="@/common/assets/images/empty.svg" />
            <p>{{ $t("base.label.empty") }}</p>
          </div>
        </div>
      </div>
      <div v-else-if="currentTab.prop === 'tab3'">
        <div class="ioc-detail">
          <div class="ioc-group">
            <div class="el-row ioc-group__item" span="24">
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-24">
                <div class="ioc-detail__box">
                  <span class="ioc-detail__label ioc-detail__label--right">{{
                      $t("historyAlarm.title.alarmName")
                  }}</span>
                  <span class="ioc-detail__content" v-if="
                    currentAlarm.alarmType == '60101' &&
                    currentAlarm.deviceName
                  ">
                    {{ currentAlarm.alarmType | dic("SENU004006") }}-{{
                        currentAlarm.deviceName
                    }}</span>
                  <span class="ioc-detail__content" v-if="currentAlarm.deviceName">{{ currentAlarm.alarmType |
                      dic("SENU004005")
                  }}-{{
    currentAlarm.deviceName
}}</span>
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-12">
                <div class="ioc-detail__box">
                  <span class="ioc-detail__label ioc-detail__label--right">{{ $t("historyAlarm.title.alarmType")
                  }}:</span>
                  <!-- <span class="ioc-detail__content">{{ currentAlarm.alarmType | dic('SENU004005')}}</span>
                               -->
                  <span class="ioc-detail__content" v-if="currentAlarm.alarmType == '60101'">
                    {{ currentAlarm.alarmType | dic("SENU004006") }}:</span>
                  <span class="ioc-detail__content" v-else>
                    {{ currentAlarm.alarmType | dic("SENU004005") }}</span>
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-12">
                <div class="ioc-detail__box">
                  <span class="ioc-detail__label ioc-detail__label--right">{{ $t("historyAlarm.title.alarmLevel") }}:
                  </span>
                  <span class="ioc-detail__content">{{
                      currentAlarm.alarmLevel | dic("SENU017")
                  }}</span>
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-12">
                <div class="ioc-detail__box">
                  <span class="ioc-detail__label ioc-detail__label--right">{{ $t("historyAlarm.title.alarmTime") }}:
                  </span>
                  <span class="ioc-detail__content">{{
                      currentAlarm.alarmTime | moment
                  }}</span>
                </div>
              </div>
              <div class="el-col el-col-24 el-col-xs-24 el-col-md-12">
                <div class="ioc-detail__box">
                  <span class="ioc-detail__label ioc-detail__label--right">设备组名称:</span>
                  <span class="ioc-detail__content">{{
                      currentAlarm.deviceWorkGroupName
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-content">
        <el-button type="primary" @click="confirmDetail" class="confirm">
          {{ $t("historyAlarm.button.close") }}
        </el-button>
      </div>
    </iocDialog>
    <el-dialog title="报警信息详情" v-dialogDrag :visible.sync="detailVisible" width="40%" class="detail-continer">
      <el-form stripe>
        <div class="detail">
          <h3 class="detailTitle">基本信息</h3>
          <el-row>
            <el-col :span="12">
              <el-form-item label="告警类型：" class="col">
                <span :class="showColor(detailData.commonAlarmType)">{{
                    detailData.commonAlarmType | dic("SENU097003004")
                }}</span>
                <!-- <span :class="detailData.subSystem == '4' ? showColor( detailData.commonAlarmType) : showColor( detailData.alarmType)">{{detailData.subSystem == '4' ?detailData.commonAlarmTypeLabel : detailData.alarmTypeLabel}}</span> -->
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="设备告警类型：" class="col">
                {{ queryAlarmType(detailData.alarmType) }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="告警时间：" class="col">
                {{ detailData.alarmTime | moment }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="告警级别：" class="col">
                <span :class="alarmColor(detailData.alarmLevel)">
                  {{ detailData.alarmLevel | dic("SENU017") }}
                </span>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="告警描述：" class="col" v-if="detailData.subSystem == '13'">
                {{ detailData.desc }}
              </el-form-item>
              <el-form-item label="告警描述：" class="col" v-else>
                <span v-if="detailData.desc">{{ detailData.desc }}</span>
                <span v-else>
                  <span v-if="detailData.buildingName && detailData.buildingName">在{{ detailData.buildingName }}位置,{{
                      detailData.subDeviceMark | dic("SENU094")
                  }}上报
                    <span v-if="detailData.commonAlarmType" :class="showColor(detailData.commonAlarmType)">{{
                        detailData.commonAlarmType | dic("SENU097003004")
                    }}</span>
                  </span>
                </span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <div class="process-detail">
          <h3 class="detailTitle">告警详情</h3>
          <el-row>
            <el-col :span="12">
              <el-form-item label="主机类型（厂商）：" class="col">
                {{ detailData.deviceType | dic("SENU087") }}
                <span v-if="
                  detailData.deviceType ||
                  detailData.parentFactoryName ||
                  detailData.factoryName
                ">(</span>
                {{
                    detailData.subDeviceMark
                      ? detailData.parentFactoryName
                      : detailData.factoryName
                }}
                <span v-if="
                  detailData.deviceType ||
                  detailData.parentFactoryName ||
                  detailData.factoryName
                ">)</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="主机名称（编号）：" class="col">
                {{
                    detailData.subDeviceMark
                      ? detailData.parentDeviceName
                      : detailData.deviceName
                }}
                <span v-if="
                  detailData.parentDeviceName ||
                  detailData.deviceName ||
                  detailData.parentThirdAlarmDevId
                ">(</span>
                {{ detailData.parentThirdAlarmDevId }}
                <span v-if="
                  detailData.parentDeviceName ||
                  detailData.deviceName ||
                  detailData.parentThirdAlarmDevId
                ">)</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="部件名称：" class="col">
                {{ detailData.subDeviceMark ? detailData.deviceName : "" }}
                <span v-if="
                  detailData.componentThirdAlarmDevId && detailData.deviceName
                ">(</span>
                {{ detailData.componentThirdAlarmDevId }}
                <span v-if="
                  detailData.componentThirdAlarmDevId && detailData.deviceName
                ">)</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="部件编号：" class="col">
                {{ detailData.componentThirdAlarmDevId }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="唯一标识号：" class="col">
                {{ detailData.thirdAlarmDevId }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="回路：" class="col">
                {{ detailData.loopThirdAlarmDevId }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="分机号：" class="col">
                {{ detailData.childThirdAlarmDevId }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="报警：" class="col">
                {{ detailData.multiAlarmType | dic("SENU100") }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="报警所在位置：" class="col">
                {{ detailData.buildingName }}
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 楼栋基本信息 -->
          <el-row>
            <el-col :span="24">
              <div @click="isExpand = !isExpand" class="col">
                <span style="color: #2a65ff; cursor: pointer">楼栋基本信息</span>
                <el-button type="text" style="
                    margin-right: 25px;
                    font-size: 16px;
                    margin-top: 7px;
                    color: #2a65ff;
                  " :class="[
                    'iconfont-lunan icon-lunan-xiaosanjiaodown',
                    isExpand ? 'icon-transform' : '',
                  ]">
                </el-button>
              </div>
            </el-col>
          </el-row>
          <el-collapse-transition>
            <el-row v-if="isExpand">
              <el-col :span="24">
                <el-form-item label="楼栋管理员：">
                  {{ buildingPerson }}
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="安全员：" class="col">
                  {{ securityPersonnel }}
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="备用安全员：" class="col">
                  {{ alternatePersonnel }}
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="值班主机：" class="col">
                  {{ officePhone }}
                </el-form-item>
              </el-col>
            </el-row>
          </el-collapse-transition>
        </div>

        <div class="process-detail">
          <h3 class="detailTitle">处理详情</h3>
          <el-row>
            <el-col :span="12">
              <el-form-item label="处理人员：" class="col">
                {{ detailData.modifier }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="处理时间：" class="col">
                {{ detailData.modifyTime | moment }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="告警处置状态：" class="col">
                {{ queryHandleStatus(detailData.alarmState) }}
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="处理原因："
                            class="col">
                {{ queryHandleStatus(detailData.alarmState) }}
              </el-form-item>
            </el-col> -->

            <el-col :span="12">
              <el-form-item label="处理描述：" class="col">
                {{ detailData.processDesc }}
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer" v-if="detailData.alarmState == '4' || detailData.alarmState == '10'">
        <el-button @click="handelShowTaskDetail" type="primary">查看任务详情</el-button>
      </span>
    </el-dialog>
    <!-- 二维码 -->
    <el-dialog :title="templateName" :visible.sync="showQrCode" v-dialogDrag width="350px">
      <div class="qr_big" ref="printTest">
        <vue-qr :text="downloadData.url" :size="200" :logoSrc="downloadData.icon" id="printTest" :margin="5"></vue-qr>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showQrCode = false">取消</el-button>
      </span>
    </el-dialog>
    <viewer @inited="inited" :images="viewerPhotos" class="viewer" ref="viewer">
      <img v-for="src in viewerPhotos" :src="src" :key="src" />
    </viewer>
  </div>
</template>

<script>
import { api } from "../api";
import iocDialog from "@components/app-dialog";
import {
  taskOption,
  taskOptionFinish,
  tapOption,
  taskAlarmOption,
} from "@src/modules/historyAlarm/const/taskOptions.js";
import utils from "@src/common/utils";
import { Dates, Dic } from "$utils";
import vueQr from "vue-qr";
export default {
  components: {
    vueQr,
    iocDialog,
  },
  data () {
    return {
      listSearch: [],
      inputType: [1, 2, 3, 6, 7, 9, 10, 11, 12],
      drawerFilter: false,
      currentAlarm: {
        videoUrl: "", //告警
      },
      taskOption: taskOption(this),
      tapOption: tapOption(this),
      taskAlarmOption: taskAlarmOption(this),
      currentTask: {},
      currentTab: {},
      uploadVideoShow: false, //告警视频
      loadingWorderList: false,
      exportVisible: false,
      timeRange: [],
      startTime: "",
      endTime: "",
      checkAll: false,
      subLoading: false,
      checkedfields: [],
      drawer: false,
      qrInfo: {},
      showQrCode: false,
      exportDisabled: false,
      detailVisible: false,
      isExpand: false,
      detailData: {},
      templateName: "",
      executorFlag: "",
      workOrderList: [],
      tableField: [],
      fieldList: [],
      checkedWorkOrder: [],
      tableOption: {
        border: true,
        selection: true,
        stripe: true,
        column: [
          // {
          //   label: this.$t('workOrder.label.createTime'),
          //   prop: 'createTime'
          // },
        ],
      },
      templateCode: "",
      imgProp: [],
      colorProp: [],
      alarmProp: [],
      downloadData: {
        // url: "http://10.40.146.150:8081/#/pages/workorder/handle-add?templateCode=20210617000495"//需要转化成二维码的网址
        url: "", //需要转化成二维码的网址
        icon: require("../../../../src/common/assets/images/logo.png"), //二维码中间的图片,可以不设置
      },
      h5Url: utils.Cache.get("SYS_H5"),
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      viewerInstance: null,
      viewerPhotos: [],
      isIndeterminate: true,
      flowTypeIndex: "",
      tableOptionCopy: [],
      authList: [],
      buildingPerson: "",
      securityPersonnel: "",
      alternatePersonnel: "",
      officePhone: "",
    };
  },
  created () {
    if (this.$route.query && this.$route.query.templateName) {
      this.templateName = this.$route.query.templateName;
    }
    if (this.$route.query && this.$route.query.workOrderType) {
      this.workOrderType = this.$route.query.workOrderType;
    }
    if (this.$route.query && this.$route.query.executorFlag) {
      this.executorFlag = this.$route.query.executorFlag;
    }
    if (this.$route.query && this.$route.query.workFlowFlag) {
      this.workFlowFlag = this.$route.query.workFlowFlag;
    }
    if (this.$route.query && this.$route.query.templateCode) {
      this.templateCode = this.$route.query.templateCode;
    }
    this.queryWorkOrderAuthGroup();
    this.queryWorkOrderFieldList();
    this.queryWorkOrderTemplate();
  },
  mounted () { },
  methods: {
    //处理状态
    queryHandleStatus (value) {
      return Dic.findByValue("SENU068", Number(value));
    },
    alarmColor (level) {
      level = parseInt(level);
      let className = "";
      if (level === 1) {
        className = "instancy";
      }
      if (level === 2) {
        className = "severity";
      }
      if (level === 3) {
        className = "general";
      }
      if (level === 4) {
        className = "common";
      }
      return className;
    },
    showColor (val) {
      if (val == "4001") {
        return "colorRed";
      } else if (val == "4002") {
        return "colorYellow";
      } else if (
        val == "4005" ||
        val == "4008" ||
        val == "4009" ||
        val == "40099"
      ) {
        return "colorBlue";
      } else if (val == "130103") {
        return "colorYellow";
      } else if (val == "130101") {
        return "colorRed";
      } else {
        return "";
      }
    },
    queryAlarmType (value) {
      if (value && value.substr(0, 1) == "4") {
        //报警类型
        return Dic.findByValue("SENU004004", Number(value));
      } else {
        //报警类型
        return Dic.findByValue("SENU004013", Number(value));
      }
    },
    // 图片enlargeImage(fileCode) {
    enlargeImage (item) {
      this.resourceDailogShow = true;
      // this.currentResource = [item]

      this.currentResource = item;
    },
    handleView (row) {
      if (
        row.alarmType == 50101 ||
        row.alarmType == 50102 ||
        row.alarmType == 50103
      ) {
        this.uploadVideoShow = false;
      } else {
        this.uploadVideoShow = true;
      }
      const params = {
        alarmId: "1637329304966",
      };
      this.$fetch(api.workOrder.queryAlarmDetail, params).then((res) => {
        if (res && res.success) {
          this.currentAlarm = res.returnObj;
          this.currentAlarm.alarmType = res.returnObj.alarmType;
          this.currentAlarm.securityWorkGroupNames = row.securityWorkGroupNames;
          if (this.currentAlarm.similarity >= 1) {
            this.currentAlarm.similarity = 100;
          } else {
            this.currentAlarm.similarity = (
              this.currentAlarm.similarity * 100
            ).toFixed(2);
          }
          this.currentAlarm.pictureList =
            this.currentAlarm.filePicSourceLists &&
            this.currentAlarm.filePicSourceLists.length &&
            this.currentAlarm.filePicSourceLists.filter((item) => {
              if (item.picResourceType !== 2) {
                return {
                  resourceCode: item.resourceCode,
                  picResourceType: item.picResourceType,
                };
              }
            });
          // 手动告警上传视频
          this.currentAlarm.manuaAlarmPicList =
            this.currentAlarm.filePicSourceLists.filter((item) => {
              if (item.picResourceType == 2) {
                return {
                  resourceCode: item.resourceCode,
                  picResourceType: item.picResourceType,
                  resourceName: item.resourceName,
                };
              }
            });
          this.$refs.alarmDetail.open();
        } else {
          this.$message.warning(res.msgContent);
        }
      });
    },
    handleTabChange (column) {
      this.currentTab = column;
    },
    confirmDetail () {
      this.$refs.taskDetail.showSingleDialog = false;
    },
    handelShowTaskDetail () {
      if (this.currentAlarm.taskCode) {
        this.$fetch(api.bas.getTaskDetail, {
          taskCode: this.currentAlarm.taskCode,
        }).then((response) => {
          if (response && response.success) {
            //成功才打开
            this.$refs.taskDetail.open();
            const params = {
              fileInfoList: response.returnObj.fileInfoList,
              subTaskInfoList: response.returnObj.subTaskInfoList,
              taskExecutionLogList: _.sortBy(
                response.returnObj.taskExecutionLogList,
                ["operateTime"]
              ),
            };
            this.currentTask = _.assign(
              {},
              params,
              response.returnObj.taskInfo
            );
            if (this.currentTask.status == 9) {
              // 任务已完成
              this.taskOption = taskOptionFinish(this);
              // console.log(this.taskOption, "this.taskOption");
            } else if (this.currentTask.status != 9) {
              // 任务未完成
              this.taskOption = taskOption(this);
            }
          } else {
            this.$message.error(response.msgContent);
          }
        });
      } else {
        this.$message({
          showClose: false,
          message: this.$t("historyAlarm.message.unableView"),
          type: "warning",
          duration: 2000,
        });
      }
    },
    closeDialog () {
      this.$refs.alarmDetail.close();
    },
    getAlarmDetail (row) {
      // console.log(row, "=====================");
      this.buildingPerson = "";
      this.securityPersonnel = "";
      this.alternatePersonnel = "";
      this.officePhone = "";
      let params = {
        alarmId: "1637329304966",
      };
      this.$fetch(api.workOrder.queryAlarmDetail, params).then((response) => {
        if (response.success) {
          this.detailVisible = true;
          this.detailData = response.returnObj;
          this.currentAlarm = response.returnObj;
          this.alarmLevel = this.detailData.alarmLevel;

          // 两点报警列表
          // this.relationAlarmInfoList = response.returnObj.relationAlarmInfoList
          // thirdAlarmDevId主机编号-分机编号-回路-部件编号（部件地址）

          if (
            this.detailData.buildingPersonnel &&
            this.detailData.buildingPersonnel.personnelName
          ) {
            this.buildingPerson =
              this.detailData.buildingPersonnel.personnelName +
              "(" +
              this.detailData.buildingPersonnel.personnelPhone +
              ")";
          }
          if (
            this.detailData.securityPersonnelList &&
            this.detailData.securityPersonnelList.length
          ) {
            this.detailData.securityPersonnelList.forEach((item, index) => {
              this.securityPersonnel +=
                item.personnelName + "(" + item.personnelPhone + ")、";
            });
            this.securityPersonnel = this.securityPersonnel.substring(
              0,
              this.securityPersonnel.lastIndexOf("、")
            );
          }
          if (
            this.detailData.alternatePersonnelList &&
            this.detailData.alternatePersonnelList.length
          ) {
            this.detailData.alternatePersonnelList.forEach((item, index) => {
              this.alternatePersonnel +=
                item.personnelName + "(" + item.personnelPhone + ")、";
            });
            this.alternatePersonnel = this.alternatePersonnel.substring(
              0,
              this.alternatePersonnel.lastIndexOf("、")
            );
          }
          this.alternatePersonnel = this.detailData.officePhone;
        } else {
          this.$message.error(response.msgContent || "获取消防告警详情失败");
        }
      });
    },
    queryWorkOrderAuthGroup () {
      this.authList = [];
      this.$fetch(api.workOrder.queryWorkOrderAuthGroup, {
        templateCode: this.$route.query.templateCode,
      }).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
        } else {
          this.authList = response.returnObj;
        }
      });
    },
    queryWorkOrderTemplate () {
      this.$fetch(api.workOrder.queryWorkOrderTemplate, {
        templateCode: this.templateCode,
      }).then((res) => {
        if (res.success) {
          this.templateName = res.returnObj.templateName;
          this.workOrderType = res.returnObj.workOrderType;
          this.executorFlag = res.returnObj.executorFlag;
          this.workFlowFlag = res.returnObj.workFlowFlag;
        } else {
          //
        }
      });
    },
    showDrawer (isFilter = false) {
      if (isFilter==true) {
        this.tableField.forEach((el, index) => {
          el.searchValue = this.listSearch.length ? this.listSearch[index].fieldValue : ''
        })
        this.drawerFilter = true
        return
      }
      this.checkedfields = [];
      this.getFieldListCheck();
      this.$nextTick(() => {
        this.drawer = true;
      });
    },
    // 获取工单字段是否显示
    getFieldListCheck () {
      // flowType: 1,
      this.$fetch(api.workOrder.queryWorkOrderFieldAccount, {
        templateCode: this.templateCode,
        type: 2,
      }).then((res) => {
        if (res.success) {
          this.initFieldList(res.returnObj);
        } else {
          this.$message.error(res.msgContent);
          this.queryWorkOrderFieldList = false;
        }
      });
    },
    initFieldList (data) {
      this.tableField = [];
      data.forEach((el) => {
        this.tableOptionCopy.forEach((item) => {
          if (el.fieldCode == item.prop) {
            el.fieldShowCheckFlag == "1"
              ? ((item.hide = false), this.checkedfields.push(item.prop))
              : (item.hide = true);
            item['searchValue'] = ""
            let obj = Object.assign({}, item)
            this.tableField.push(obj);
          }
        });
      });
      this.tableOption.column = this.tableOptionCopy;
      this.tableField.findIndex((el) => el.flowType == 2) != -1
        ? (this.flowTypeIndex = this.tableField.findIndex(
          (el) => el.flowType == 2
        ))
        : (this.flowTypeIndex = this.tableField.length);

      this.queryWorkOrderFieldList = false;
      // console.log(this.tableOptionCopy, "===this,tableOption");
      console.log(this.tableField, "===this,tableOption");
    },
    handleCheckAllChange (val) {
      this.checkedfields = val
        ? this.tableOption.column.map((el) => {
          return el.prop;
        })
        : [];
      this.isIndeterminate = false;
    },
    handleCheckedTableChange (value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.tableField.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.tableField.length;
    },
    // 条件查询btn回调
    subDrawerFilter (isFilter = true) {
      setTimeout(() => {
        this.drawerFilter = false
      }, 200);
      if (!isFilter) {
        this.tableField.forEach(el => {
          el.searchValue = ''
        })
        this.getList()
        return
      }
      let listSearch = this.tableField.map(el => {
        return {
          fieldCode: el.prop,
          fieldValue: el.searchValue
        }
      })
      this.getList(listSearch)
    },
    // 显隐显示btn回调
    subDrawer () {
      if (this.checkedfields.length < 1) {
        this.$message.warning("请至少选择一项");
        return;
      }
      this.subLoading = true;
      this.$fetch(api.workOrder.updateWorkOrderFieldAccount, {
        fieldCodeList: this.checkedfields,
        type: 2,
        templateCode: this.templateCode,
      }).then((res) => {
        if (res.success) {
          this.getFieldListCheck();
        } else {
          this.$message.error(res.msgContent);
        }
      });
      setTimeout(() => {
        this.subLoading = false;
        this.drawer = false;
      }, 500);
    },
    showViewer (src) {
      this.viewerPhotos = [src];
      src && this.viewerInstance.show();
    },
    inited (viewer) {
      this.viewerInstance = viewer;
    },
    handleQr () {
      if (!this.fieldList || !this.fieldList.length) {
        this.$message.warning("工单模板为空,请先创建工单");
        return;
      }
      this.downloadData.url =
        this.h5Url +
        "/#/pages/workorder/handle-add?templateCode=" +
        this.templateCode;
      this.showQrCode = true;
    },
    closeTimeDialog () {
      this.exportVisible = false;
      this.timeRange = [];
      this.startTime = "";
      this.endTime = "";
    },
    timeConfirm () {
      const self = this;
      if (!this.workOrderList.length) {
        this.$message.warning("暂无数据可以导出");
        return;
      }
      // console.log(this.timeRange, this.startTime, "========change");
      if (this.timeRange) {
        this.startTime = this.timeRange[0];
        this.endTime = this.timeRange[1];
      }

      self.exportDocument();
    },
    exportFile () {
      this.timeRange.push(
        Dates.format(
          new Date(Date.now() - 30 * 24 * 3600 * 1000),
          "yyyy-MM-dd 00:00:00"
        )
      );
      this.timeRange.push(Dates.format(new Date(), "yyyy-MM-dd 23:59:59"));
      this.exportVisible = true;
    },
    exportDocument () {
      this.exportDisabled = true;
      this.$fetchDownLoad(
        api.workOrder.exportList,
        {
          templateCode: this.templateCode,
          startTime: this.startTime,
          endTime: this.endTime,
        },
        { responseType: "arraybuffer" }
      ).then((response) => {
        if (response.data || response.success) {
          // if (this.timeRange) {
          //   start_time = this.startTime;
          //   end_time = this.endTime;
          //   let startTime = new Date(start_time).getTime();
          //   let endTime = new Date(end_time).getTime();
          //   if (endTime - startTime > 30 * 24 * 60 * 60 * 1000) {
          //     this.$message.warning("导出数据时间跨度不可超过30天");
          //     return;
          //   }
          // }
          const content = response.data;
          const blob = new Blob([content], { type: "application/zip" });
          const fileName =
            this.templateName +
            Dates.format(Date.now(), "yyyyMMddHHmmssms") +
            ".zip";
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
          this.exportDisabled = false;
          this.$message.success("导出成功");
          this.exportVisible = false;
        } else {
          this.$message.error("导出请求失败，请稍后重试");
        }
      });
    },
    getList (listSearch = []) {
      this.loadingWorderList = true;
      const params = {
        templateCode: this.templateCode,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
      };
      this.listSearch = JSON.parse(JSON.stringify(listSearch))
      if (listSearch.length) {
        params.workOrderList = listSearch
      }
      this.$fetch(api.workOrder.queryWorkOrderList, params).then((res) => {
        if (res.success) {
          setTimeout(() => {
            this.loadingWorderList = false;
          }, 1000);
          this.workOrderList = res.returnObj.list;
          this.page.total = res.returnObj.total;
        } else {
          this.loadingWorderList = false;
          this.$message.error(res.msgContent);
        }
      });
    },
    queryWorkOrderFieldList () {
      // flowType: 1,
      this.queryWorkOrderFieldList = true;
      this.$fetch(api.workOrder.queryWorkOrderFieldList, {
        // 流程类型，1：派单人，2：执行人
        templateCode: this.templateCode,
      }).then((res) => {
        if (res.success) {
          this.fieldList = res.returnObj;
          this.convertOption();
          this.getList();
        } else {
          this.queryWorkOrderFieldList = false;
          this.$message.error(res.msgContent);
        }
      });
    },
    convertOption () {
      this.imgProp = [];
      // this.tableOption.column
      this.tableOptionCopy = this.fieldList.map((item) => {
        if (parseInt(item.type) === 7 || parseInt(item.type) === 12) {
          // this.imgProp = item.fieldCode
          this.imgProp.push(item.fieldCode);
        }
        if (parseInt(item.type) === 5) {
          this.colorProp.push(item.fieldCode);
          return {
            label: item.fieldName,
            prop: item.fieldCode,
            flowType: item.flowType,
            type: item.type,
            info: item.info,
            optionName: item.info.split(";")[3].split("|")
          };
        }
        if (parseInt(item.type) === 13) {
          this.alarmProp.push(item.fieldCode);
        }
        // if (parseInt(item.type) === 12) {
        //   this.imgProp.push(item.fieldCode)
        // }
        if (parseInt(item.type) === 10) {
          return {
            label: item.fieldName,
            prop: item.fieldCode,
            flowType: item.flowType,
            type: item.type,
            info: item.info,
            formatter: (row, value) => {
              if (value) {
                let list = [];
                value.split("|").map((el) => {
                  let name =
                    el.split(":")[0].split("-")[0] +
                    (el.split(":")[0].split("-")[1]
                      ? "(" + el.split(":")[0].split("-")[1] + ")"
                      : "");
                  list.push(name);
                });
                return list.join(",");
              } else {
                return value;
              }
            },
          };
        }
        if (parseInt(item.type) === 8) {
          return {
            label: item.fieldName,
            prop: item.fieldCode,
            flowType: item.flowType,
            info: item.info,
            type: item.type,
            formatter: (row, value) => {
              return value ? value.split("||")[1] : value;
            },
          };
        }
        if (parseInt(item.type) === 9 || parseInt(item.type) === 11) {
          return {
            label: item.fieldName,
            prop: item.fieldCode,
            flowType: item.flowType,
            type: item.type,
            info: item.info,
            formatter: (row, value) => {
              // return value ? value.split('|')[1] : value
              return value ? value.split(":")[0] : value;
            },
          };
        }
        return {
          label: item.fieldName,
          prop: item.fieldCode,
          flowType: item.flowType,
          type: item.type,
          info: item.info,
          // type:item.type
        };
      });
      this.tableOptionCopy.push({
        label: this.$t("workOrder.label.createTime"),
        prop: "createTime",
      });
      this.tableOptionCopy.push({
        label: "创建人",
        prop: "creatorName",
      });

      this.getFieldListCheck();
      // console.log(this.tableOption.column);
      // console.log(this.imgProp);
      // console.log(this.colorProp);
    },
    handleDel () {
      if (this.checkedWorkOrder.length === 0) {
        this.$message({
          type: "warning",
          duration: 2000,
          message: "请选择你要删除的工单",
        });
        return;
      }
      const params = {
        workOrderCodeList: this.checkedWorkOrder,
        templateCode: this.templateCode,
      };
      this.$confirm("此操作将删除该工单,确认继续?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$fetch(api.workOrder.deleteWorkOrder, params).then(
            (response) => {
              if (!response.success) {
                this.$message({
                  message: response.msgContent,
                  type: "error",
                  duration: 2000,
                });
                return;
              }
              this.$message({
                message: "删除成功",
                type: "success",
                duration: 2000,
              });
              this.getList();
            }
          );
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    handleAdd () {
      if (!this.fieldList || !this.fieldList.length) {
        this.$message.warning("工单模板为空，无法创建工单");
        return;
      }
      this.$router.push({
        path: "/workorder/detail",
        query: {
          templateCode: this.templateCode,
          templateName: this.templateName,
          workOrderType: this.workOrderType,
          executorFlag: this.executorFlag, //是否有执行人
          workFlowFlag: this.workFlowFlag,
        },
      });
    },
    editFlow () {
      this.$router.push({
        path: "/workorder/edit",
        query: {
          templateCode: this.templateCode,
          index: 1,
        },
      });
    },
    editTable () {
      this.$router.push({
        path: "/workorder/edit",
        query: {
          templateCode: this.templateCode,
          workOrderType: this.workOrderType,
          executorFlag: this.executorFlag, //是否有执行人
          workFlowFlag: this.workFlowFlag,
        },
      });
    },
    deleteTable () {
      this.$confirm("您确定删除表格吗?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const params = {
          templateCode: this.templateCode,
        };
        this.$fetch(api.workOrder.deleteWorkOrderField, params).then(
          (response) => {
            if (response.success) {
              this.$message({
                message: "删除成功",
                type: "success",
                duration: 2000,
              });
              this.queryWorkOrderFieldList();
            } else {
              this.$message({
                message: response.msgContent,
                type: "error",
                duration: 2000,
              });
            }
          }
        );
      });
    },
    handleCurrentChange (val) {
      this.page.currentPage = val;
      this.getList();
    },
    handleRowClick (row, index) {
      // console.log(row, "====rowdata");
      let query = {
        templateCode: this.templateCode,
        templateName: this.templateName,
        workOrderCode: row.workOrderCode,
        workOrderType: this.workOrderType,
        workFlowFlag: this.workFlowFlag,
        executorFlag: this.executorFlag,
      };
      if (index == -1) {
        // 编辑状态
        query.status = "edit";
      }
      this.$router.push({
        path: "/workorder/detail",
        query: query,
      });
    },
    getImgPath (item, type) {
      // console.log(item);
      // 适配app端多张图片显示 默认显示第一张
      return item ? utils.Bus.imgPath(item[type].split("|")[0]) : "";
    },
    handleSizeChange (val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleBack () {
      this.$router.go(-1);
    },
    handleSelectionChange (items) {
      this.checkedWorkOrder = items.map((item) => {
        return item.workOrderCode;
      });
    },
  },
};
</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";

.detail {
  @include set_theme_color(background-color, blur-color);
  // background: #00407b;

  padding: 10px;
}

.process-detail {
  @include set_theme_color(background-color, blur-color);

  margin-top: 10px;
  padding: 10px;
}

.menu-right {
  display: flex;
}

.time-range {
  padding: 0 10px;
}

.colorSpan {
  padding: 8px;
  margin-right: 3px;
  border-radius: 4px;
}

.showBorder {
  .ioc-theme .el-table {
    border: none !important;
  }

  .el-table__row>td {
    border: none;
  }

  .el-table--border {
    border: none;
  }

  .el-table--border::after,
  .el-table--group::after {
    display: none !important;
  }

  .el-table thead .is-leaf {
    border-right: solid;

    // border-right: none;
    &:hover {
      // border-right: solid;
    }

    @include set_theme_color(border-color, active-border-color);
  }
}

.el-drawer {
  @include set_theme_color(background-color, dialog-main-bg-color);
}

.qr_big {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;
}

.el-drawer__header {
  font-size: 16px;
  color: #fff;
}

.demo-drawer__content {
  height: 75vh;
  margin: 30px;
  overflow-y: auto;
  overflow-x: hidden;
  margin: 30px;

  .el-collapse-item__header {
    @include set_theme_color(background-color, dialog-main-bg-color);
    color: #fff;
    border-color: rgba(153, 153, 153, 0.5);
  }

  .el-collapse-item__wrap {
    border: none;
  }

  .el-collapse-item__content {
    padding-bottom: 10px;
    @include set_theme_color(background-color, dialog-main-bg-color);
  }

  .title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .filterCheck {
    margin-top: 60px !important;
  }

  .filterCheck::before {
    content: "";
    display: inline-block;
    padding: 4px 86px;
    background: #fff;
    text-align: center;
    border-radius: 0px;
    position: absolute;
    font-size: 14px;
    top: -35px;
  }

  .checkItem {
    width: 210px;
    margin: 20px;
    display: flex;

    .el-checkbox__label {
      width: 200px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}

.demo-drawer__footer {
  position: absolute;
  bottom: 25px;
  width: 100%;
  text-align: center;
}
</style>